import React, { useState } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import privateAxios from '../../utils/axios/privateAxios';
import publicAxios from '../../utils/axios/publicAxios';
import Notification from '../../components/Notification/Notification';
import { Link, useNavigate } from 'react-router-dom';
import './CreateForm.css';

const CreateForm = () => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [display, setDisplay] = useState(false);
    const [imageFile, setImageFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState({ type: '', message: '' });

    const userId = localStorage.getItem('userId');
    const navigate = useNavigate();

    const showNotification = (type, message) => {
        setNotification({ type, message });
        setTimeout(() => {
            setNotification({ type: '', message: '' });
        }, 5000);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setImageFile(file);
        setPreviewUrl(URL.createObjectURL(file));
    };

    const uploadImageToS3 = async () => {
        if (!imageFile) return '';

        try {
            const response = await privateAxios.get('/private/generate-upload-url', {
                params: {
                    filename: imageFile.name,
                    filetype: imageFile.type,
                },
            });

            const { url } = response.data;

            await publicAxios.put(url, imageFile);

            const uploadedUrl = url.split('?')[0]; // S3 public URL
            return uploadedUrl;
        } catch (error) {
            console.error('Image upload failed:', error);
            throw new Error('Failed to upload image.');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let uploadedImageUrl = '';
            if (imageFile) {
                uploadedImageUrl = await uploadImageToS3();
            }

            const formData = {
                title,
                description,
                display,
                imageUrl: uploadedImageUrl || '',
            };

            const response = await privateAxios.post(`/private/create-form/${userId}`, formData);

            const { formId } = response.data;
            console.log(response.data)
            showNotification('success', 'Form created successfully!');

            setTimeout(() => {
                navigate(`/admin-form/${formId}`);
            }, 3000);
        } catch (error) {
            console.error(error);
            showNotification('error', error.response?.data?.message || 'Failed to create form.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="create-form-container">
            <Notification
                type={notification.type}
                message={notification.message}
                onClose={() => setNotification({ type: '', message: '' })}
            />
            <Link to="/admin-dashboard" className="create-form-back-button">Back to Dashboard</Link>
            <h2>Create New Application Form</h2>

            <form onSubmit={handleSubmit}>
                <label>Form Title:</label>
                <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                <label>Description:</label>
                <ReactQuill value={description} onChange={setDescription} theme="snow" />

                <label>Upload Image (optional):</label>
                <input type="file" accept="image/*" onChange={handleImageChange} />
                {previewUrl && <img src={previewUrl} alt="Selected preview" className="image-preview" />}

                <label className="checkbox-label">
                    <input
                        type="checkbox"
                        checked={display}
                        onChange={() => setDisplay(!display)}
                    />
                    Display
                </label>

                <div className="form-actions">
                    <button
                        type="button"
                        className="cancel-button"
                        onClick={() => navigate('/admin-dashboard')}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Creating Form...' : 'Create Form'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateForm;